export default "__VITE_ASSET__CFw_YQPm__"